import { FORMULAIRE_FORMALITE_SLICE_NAME, FORMULAIRE_REDUCER_NAME } from './constants';
import { FormulaireStateType } from './types';

export const formulairesFormaliteSelector = (s: FormulaireStateType) =>
    s[FORMULAIRE_REDUCER_NAME][FORMULAIRE_FORMALITE_SLICE_NAME].main;
